import React, { useEffect } from "react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import * as EnquiryAction from "../../../actions/enquiryAction";
import { corpEnqFollowupStatueValue } from "../../../resources/enquiryStatus";
import { useSnackbar } from "notistack";
import SearchBar from "./searchBar";

export default function FollowUp({ followUpData, page }) {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const getPageNum = useSelector((state) => state?.enquiryListing?.followup_page_num);
  const enquiriesSearchVal = useSelector((state) => state?.enquiryListing?.corpFollowupSearchValue);
  const startDate = useSelector((state) => state.enquiryListing.filterStartDate);
  const endDate = useSelector((state) => state.enquiryListing.filterEndDate);
  const [state, setState] = React.useState({
    status: undefined,
  });

  const enquiryStatusChange = (id, status) => {
    setState({ ...state, status });
    dispatch(EnquiryAction.updateEnquiryStatus(id, status, refreshEnquiries));
    enqueueSnackbar("Udated successfully.", {
      variant: "success",
    });
  };

  useEffect(() => {
    if(enquiriesSearchVal === "" && startDate === null && endDate === null && followUpData?.next_page_id === null && followUpData?.current_page > 1 && followUpData?.results.length === 0) {
      dispatch(EnquiryAction.getEnquiryFollowuplist(1));
      dispatch(EnquiryAction.setPageNum(1, "follow-up"));
    }else if(enquiriesSearchVal !== "" && 
      followUpData?.next_page_id === null && 
      followUpData?.current_page > 1 && 
      followUpData?.results.length === 0)
    {
      dispatch(EnquiryAction.searchEnquiry(enquiriesSearchVal, "follow-up", 1))
      dispatch(EnquiryAction.setPageNum(1, "follow-up"));
    }else if(startDate !== null && endDate !== null && 
      followUpData?.next_page_id === null && 
      followUpData?.current_page > 1 && 
      followUpData?.results.length === 0)
    {
      dispatch(EnquiryAction.searchEnquiry(enquiriesSearchVal, "follow-up", 1));
      dispatch(EnquiryAction.setPageNum(1, "follow-up"));
    }else if(enquiriesSearchVal !== "" && startDate !== null && endDate !== null && 
      followUpData?.next_page_id === null && 
      followUpData?.current_page > 1 && 
      followUpData?.results.length === 0)
    {
      dispatch(EnquiryAction.searchEnquiry(enquiriesSearchVal, "follow-up", 1));
      dispatch(EnquiryAction.setPageNum(1, "follow-up"));
    }
  }, [followUpData]);

  const refreshEnquiries = () => {
    if(enquiriesSearchVal !== ""){
      dispatch(EnquiryAction.searchEnquiry(enquiriesSearchVal, "follow-up", getPageNum));
      dispatch(EnquiryAction.getResolvedEnquirylist(getPageNum));
    }else if(startDate !== null && endDate !== null){
      dispatch(EnquiryAction.searchEnquiry(enquiriesSearchVal, "follow-up", getPageNum));
      dispatch(EnquiryAction.searchEnquiry(enquiriesSearchVal, "resolved", getPageNum));
    }
    else{
      dispatch(EnquiryAction.getEnquiriesList(getPageNum));
      dispatch(EnquiryAction.getEnquiryFollowuplist(getPageNum));
      dispatch(EnquiryAction.getResolvedEnquirylist(getPageNum));
    }
  };


  return (
   <div>
   <SearchBar status="follow-up" searchValue={enquiriesSearchVal}/>
   {followUpData?.results.length === 0 && 
     <div className="enquiry-card-holder">No Record Found!</div>
   }
      <div className="overflow--scroll" style={{ marginBottom: '10px' }}>
        {followUpData?.results &&
          followUpData?.results.length > 0 &&
          followUpData?.results.map((item) => (
            <div className="enquiry-card-holder">
              <div className="organization-details" style={{width: "450px"}}>
              <span style={{display:"block", color: "#2196F3"}}>{item?.ref_id? `#${item.ref_id}`: "No ref id"}</span>
                <h1>{item.organisation}</h1>
                <div className="info">
                  <p>
                    Enquired on {moment(item.created).format("Do MMMM, YYYY, h:mm a")}
                  </p>
                  <p>Enquired by {item.emp_name}</p>
                </div>
              </div>
              <div className="contact-info">
                <div className="title">
                  <p>Contact info</p>
                </div>
                <div className="contact-details">
                  <p className="email">{item.email}</p>
                  <p>{item.mobile}</p>
                </div>
              </div>
              <div className="contact-info">
                <div className="title">
                  <p>Message</p>
                </div>
                <div className="contact-details">
                  <p className="message-limit" title={item.message}>{item.message}</p>
                </div>
              </div>
              <div>
                <select
                  className="status-dropdown"
                  value={item.status}
                  onChange={(event) =>
                    enquiryStatusChange(item.id, event.target.value)
                  }
                >
                  {corpEnqFollowupStatueValue.length > 0 &&
                    corpEnqFollowupStatueValue.map((options) => (
                      <option value={options?.value}>{options?.name}</option>
                    ))}
                </select>
              </div>
            </div>
          ))}
      </div>
   </div>
  );
}
